import { axiosRequest } from '@/util/axios-request'
const method = 'get'
const listUrl = '/web/msg/list'
const addUrl = '/web/msg/add'
const detailUrl = '/web/msg/detail'
const cancelUrl = '/web/msg/cancel'
const topUrl = '/web/msg/top'
const exportUrl = '/web/msg/export'

// 消息列表
export const listFn = params => axiosRequest({ url: listUrl, method, params })

// 消息添加
export const addFn = data => axiosRequest({ url: addUrl, data })

// 消息详情
export const detailFn = params => axiosRequest({ url: detailUrl, method, params })

// 消息撤回
export const cancelFn = data => axiosRequest({ url: cancelUrl, data })

// 消息置顶
export const topFn = data => axiosRequest({ url: topUrl, data })

// 消息列表
export const exportFn = params => axiosRequest({ url: exportUrl, method, params })

// 签字消息导出列表查询
export const exportPdfList = params => axiosRequest({ url: '/web/msg/exportPdfList', method, params })

// 签字消息PDF导出
export const exportPdf = params => axiosRequest({ url: '/web/msg/exportPdf', method, params })
